import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const updateFileAws = (axios: IAxiosInstance) => {
  return async ({
    key,
    contentType,
    usePrimary,
    data,
    putUrl,
  }: ISchema["#/definitions/IUpdateFileAwsArgs"]) => {
    await axios.noRetry.put<ISchema["#/definitions/IUpdateFileAwsResponse"]>(
      putUrl,
      data,
      {
        params: {
          Key: key,
          ContentType: contentType,
          usePrimary,
        },
        headers: {
          "Content-Type": contentType,
        },
        withCredentials: false,
        baseURL: undefined,
      }
    );
  };
};
